"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueToKey = exports.keyToValue = void 0;
function keyToValue(key) {
    if (typeof key === "number") {
        // react-aria's selection manager always returns strings, so we probably
        // won't actually hit this line, but just in case.
        return key;
    }
    else if (typeof key === "string") {
        if (key === "__VALUE:null") {
            return null;
        }
        else if (key === "__VALUE:undefined") {
            return undefined;
        }
        else if (key.startsWith("__VALUE:boolean:")) {
            return (key.split(":")[2] === "true");
        }
        else if (key.startsWith("__VALUE:number")) {
            return Number(key.split(":")[2]);
        }
        else {
            return key;
        }
    }
    else {
        throw new Error(`Unsupported key ${key}`);
    }
}
exports.keyToValue = keyToValue;
function valueToKey(value) {
    if (typeof value === "string") {
        return value;
    }
    else if (typeof value === "number") {
        // Despite using the Key type, react-aria's select manager always returns strings,
        // so tag this value as really being a number.
        return `__VALUE:number:${value}`;
    }
    else if (typeof value === "boolean") {
        return `__VALUE:boolean:${value}`;
    }
    else if (value === null) {
        return "__VALUE:null";
    }
    else if (value === undefined) {
        return "__VALUE:undefined";
    }
    else {
        throw new Error(`Unsupported value ${value}`);
    }
}
exports.valueToKey = valueToKey;
